<template>
  <div v-if="revision && assignRegulationsForm" class="-mx-8">
    <DataTable
        v-model:filters="filters"
        :value="regulations"
        dataKey="id"
        :globalFilterFields="['name']"
        removableSort
    >
      <template #header>
        <div class="flex items-stretch justify-between px-6 space-x-3">
          <IconField iconPosition="left">
            <InputIcon>
              <i class="pi pi-search"/>
            </InputIcon>
            <InputText v-model="filters['global'].value" placeholder="Search Regulations" class="py-2"/>
          </IconField>

          <Button :label="$t('common.save')" @click="submit"
                  v-if="$auth.hasPermission('update:device-revision-regulations')"/>
        </div>
      </template>
      <Column field="name" :header="$t('pages.admin.devices.device_revisions.device_revision.device_regulations.device_revision_regulations_view.name')" class="pl-8" sortable></Column>
      <Column field="description" :header="$t('pages.admin.devices.device_revisions.device_revision.device_regulations.device_revision_regulations_view.description')" header="Description" class="pl-8" sortable></Column>
      <Column style="width: 3rem">
        <template #body="{ data }">
          <Checkbox :value="data" v-model="selectedRegulations"
                    :disabled="!$auth.hasPermission('update:device-revision-regulations')"></Checkbox>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import {mapStores} from "pinia";
import {useRegulationsStore} from "@/stores/regulations.js";
import {useForm} from "laravel-precognition-vue";
import {FilterMatchMode} from "primevue/api";
import DevicePropertiesForm from "@/Forms/Device/DevicePropertiesForm.vue";

export default {
  name: "DeviceRevisionRegulationsView",
  components: {DevicePropertiesForm},
  data() {
    return {
      loading: true,
      regulations: undefined,
      selectedRegulations: [],
      assignRegulationsForm: undefined,
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        },
      }
    }
  },
  computed: {
    ...mapStores(useRegulationsStore),
    revision() {
      return this.$attrs.revision;
    },
  },
  methods: {
    async submit() {
      try {
        this.assignRegulationsForm.regulation_ids = this.selectedRegulations.map(r => r.id);
        await this.assignRegulationsForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.devices.device_revisions.device_revision.device_regulations.device_revision_regulations_view.regulations_linked_to_device_revision'),
          life: 3000
        });
        this.$emit('refresh-device-revision')
      } catch (e) {
        this.$toast.add({
          severity: 'info',
          summary: this.$t('common.cancelled'),
          detail: this.$t('pages.admin.devices.device_revisions.device_revision.device_regulations.device_revision_regulations_view.regulations_were_not_linked_to_device_revision'),
          life: 3000
        });
        console.log(e);
      }
    }
  },
  async mounted() {
  },
  watch: {
    'revision': {
      async handler(newValue, oldValue) {
        if (newValue) {
          try {
            const response = await this.regulationsStore.indexRegulations({per_page: 1000});
            this.regulations = response.data.sort((a, b) => a.name.localeCompare(b.name));
            this.selectedRegulations = this.regulations.filter(r => this.revision.regulations.some(fr => fr.id === r.id));
            this.assignRegulationsForm = useForm('post', `/device-revisions/${this.revision.id}/regulations`, {
              regulation_ids: this.selectedRegulations.map(r => r.id)
            });
          } catch (e) {
            console.log(e);
            this.regulations = null;
            this.selectedRegulations = null;
            this.assignRegulationsForm = null;
          }
        }
      },
      immediate: true,
    }
  },
}
</script>
